import { BookingV2BoatOption } from '../dtos/booking-v2.dtos';

// True when both options describe the same boat selection. An id comparison alone is not
// enough: manual boats (`id: -1`) and new-boat drafts (`id: -2`) all share their pseudo id,
// and `selectOwnerBoat()` re-emits an otherwise identical boat with the owner attached.
//
// Every field of BookingV2BoatOption is compared, `ownerLabel` included: the caller skips
// the selection on a match, so anything left out here would be dropped instead of applied.
// Keep this in sync when the DTO grows a field.
export function isSameBoatSelection(
    a: BookingV2BoatOption | null | undefined,
    b: BookingV2BoatOption | null | undefined,
): boolean {
    if (a === b) {
        return true;
    }
    if (!a || !b) {
        return false;
    }
    return a.id === b.id
        && (a.origin ?? 'existing') === (b.origin ?? 'existing')
        && a.name === b.name
        && a.licensePlate === b.licensePlate
        && a.length === b.length
        && a.width === b.width
        && a.depth === b.depth
        && a.ownerLabel === b.ownerLabel
        && (a.ownerId ?? null) === (b.ownerId ?? null)
        && (a.ownerKind ?? null) === (b.ownerKind ?? null);
}
